import { File } from '@modules/missions/file'

export function MissionFile() {
  return <File />
}
